// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"24":"d6a3cdde","71":"c8cea4bf","99":"2f424982","324":"a6692b29","772":"b40766a5"}[chunkId] + ".chunk.js";
};